// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  residentId: __t.u64().primaryKey().name("resident_id"),
  cityId: __t.u64().name("city_id"),
  versonaId: __t.u64().name("versona_id"),
  houseStructureId: __t.u64().name("house_structure_id"),
  invitedBy: __t.identity().name("invited_by"),
  originSettlementId: __t.u64().name("origin_settlement_id"),
  since: __t.timestamp(),
});
